import { BotFeatures } from '@feedyou-ai/feedbot-schema'

export function getNoteTooltipText(storageName: string | undefined): string {
  if (storageName !== undefined) {
    return `Answer will be stored into {${storageName}} variable`
  }

  return `Storage alias is not set so answers of this question won't be stored`
}

export function isAttachmentEnabledForQuestionStep(sdkFeatures: BotFeatures[]): boolean {
  return sdkFeatures?.includes(BotFeatures.QUESTION_STEP_ATTACHMENT)
}
